import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { DeviceBase } from "@preveil-api";
import { GetUserDevicesApiResponse, Message, SettingsErrorMessages, useAppDispatch, useAppSelector, useGetUserDevicesMutation } from "src/common";
import { PageHeader, ToolbarWrapper } from "src/components";
import { DeviceListView } from ".";
import { uiActions } from "src/store";
import { RootState } from "src/store/configureStore";

function DeviceManagementComponent() {
  const dispatch = useAppDispatch();
  const current_account = useAppSelector((state: RootState) => state.account.current_account);
  const [devices, setDevices] = useState<DeviceBase[]>([]);
  const [getDevices, { isLoading }] = useGetUserDevicesMutation();

  /* Description: On initial load: Call Get User Devices */
  useEffect(() => {
    getUserDevices();
  }, []);

  /* Description: Gets the users devices from the backend and sets it in the store, also handles errors. */
  async function getUserDevices() {
    if (!!current_account) {
      await getDevices({ user_id: current_account.user_id })
        .unwrap()
        .then((response: GetUserDevicesApiResponse) => {
          setDevices(response);
        })
        .catch((msg) => {
          dispatch(
            uiActions.handleRequestErrors(
              new Message(SettingsErrorMessages.error_fetching_devices),
              msg,
            ),
          );
        });
    }
  }

  return (
    <>
      <PageHeader>
        <h1>Device Management</h1>
      </PageHeader>
      <Card className="card-section h-100">
        <ToolbarWrapper
          refreshAction={() => getUserDevices()}
          refreshTooltipContent="Refresh Devices"
          isLoading={isLoading}
          paginationInfo={<span><b>{devices.length} </b>Device{devices.length > 1 ? "s" : ""}</span>}
        />
        {!!current_account && (
          <DeviceListView
            loading={isLoading}
            current_account={current_account}
            devices={devices}
            setDevices={setDevices}
          ></DeviceListView>
        )}
      </Card>
    </>
  );
}

export default React.memo(DeviceManagementComponent);
